import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseConfigWarehouseActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Warehouse/WarehouseBrowser")
	}

	render() {
		return (
			<Activity 
				name="WarehouseConfigWarehouse"
				RenderedComponent={this.RenderedComponent}
				context="WarehouseConfigWarehouse"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseConfigWarehouseActivity)
